import { FormControl, FormGroup, InputGroup } from "react-bootstrap";
import * as React from "react";
import { IconButton } from "./TooltipControls";
import { clipboard } from "electron";
import { MainContext } from "../views/MainWindow";
function CopyClipboardInput(props) {
    const { api } = React.useContext(MainContext);
    const [showElement, setShowElement] = React.useState(false);
    const handleButtonClick = () => {
        try {
            clipboard.writeText(props.inputValue);
            // show confirmation text
            setShowElement(true);
            // hide after 3 seconds
            setTimeout(() => {
                setShowElement(false);
            }, 3000);
        }
        catch (err) {
            // apparently clipboard gets lazy-loaded and that load may fail for some reason
            api.showErrorNotification("Failed to access clipboard", err, {
                allowReport: false,
            });
        }
    };
    return (React.createElement(FormGroup, null,
        React.createElement(InputGroup, null,
            React.createElement(FormControl, { type: "text", value: props.inputValue ?? "", readOnly: true }),
            React.createElement(InputGroup.Addon, null,
                React.createElement(IconButton, { className: "btn-embed", icon: "clipboard-copy", tooltip: "Copy to clipboard", onClick: handleButtonClick }))),
        React.createElement("p", { className: "login-copy-to-clipboard", style: { visibility: showElement ? "visible" : "hidden" } }, "\u2713 Copied to clipboard")));
}
export default CopyClipboardInput;
